import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const syncFavorites = async () => {
    try {
      const local = JSON.parse(localStorage.getItem("streateat_favorites") || "[]");
      const { data } = await api.post("/me/favorites/merge", { slugs: local });
      localStorage.setItem("streateat_favorites", JSON.stringify(data.favorites));
      window.dispatchEvent(new Event("favorites-changed"));
    } catch (e) { console.error("syncFavorites failed", e); }
  };

  useEffect(() => {
    const t = localStorage.getItem("streateat_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => { setUser(r.data); syncFavorites(); }).catch(() => localStorage.removeItem("streateat_token")).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("streateat_token", data.token);
    setUser(data.user);
    await syncFavorites();
    return data.user;
  };

  const register = async (name, email, password, accountType = "owner") => {
    const { data } = await api.post("/auth/register", { name, email, password, account_type: accountType });
    localStorage.setItem("streateat_token", data.token);
    setUser(data.user);
    await syncFavorites();
    return data.user;
  };

  const logout = () => { localStorage.removeItem("streateat_token"); setUser(null); };
  const refresh = async () => { const r = await api.get("/auth/me"); setUser(r.data); return r.data; };

  return <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
